import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "underscore.string";

@Pipe({
  name: 'chop'
})
export class ChopPipe implements PipeTransform {

  transform(value: any, quant?: any): any {
    return _.chop(value,quant)[0]+'...';
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/chop.pipe.ts